import React from "react"
import { Link, graphql } from "gatsby"
import { GatsbyImage} from "gatsby-plugin-image"
import parse from "html-react-parser"
import AuthorBlock from '../components/author_block'

// We're using Gutenberg so we need the block styles
// these are copied into this project due to a conflict in the postCSS
// version used by the Gatsby and @wordpress packages that causes build
// failures..
// @todo update this once @wordpress upgrades their postcss version
// import "../css/@wordpress/block-library/build-style/style.css"
// import "../css/@wordpress/block-library/build-style/theme.css"

import Layout from "../components/layout"
// import Bio from "../components/bio"
import Seo from "../components/seo"
import DemoSection from "../components/demo_section"

import './blog-post.scss'

const BlogPostTemplate = ({ data: { previous, next, post } }) => {
  const featuredImage = {
    data: post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData,
    alt: post.featuredImage?.node?.alt || ``,
  }

  let authorPhoto;
  post.author.node.avatar.url ? authorPhoto = post.author.node.avatar.url : authorPhoto = '';
  
  const authorData = {
    name: post.author.node.name || 'Doctor Genius Marketing',
    date: post.date || ``,
    photo: authorPhoto,
    userName: post.author.node.slug,
    fbLink: '',
    twLink: '',
    instaLink: '',
    linkedInLink: ''
  }
  return (
    <Layout>

      <article
        className="blog-post col-sm-12 col-md-12 col-lg-8 offset-lg-2"
        itemScope
        itemType="http://schema.org/Article"
      >
        <div className="container blog-post">
        <nav className="blog-post-nav">
        <ul
          className="blog-pagination"
        >
          <li>
            {previous && (
              <Link to={`/blog/` + previous.slug} rel="prev">
                ← Prev
              </Link>
            )}
          </li>

          <li>
            {next && (
              <Link to={`/blog/` + next.slug} rel="next">
                Next →
              </Link>
            )}
          </li>
        </ul>
      </nav>
      { authorData.name === 'Doctor Genius Marketing (L)'
        ? null
        :<AuthorBlock authorDetails={authorData} />
      }
        <header>
          <h1 className="blog-title text-center" itemProp="headline">{parse(post.title)}</h1>

          <p className="blog-date">{post.date}</p>
          <hr />

          {/* if we have a featured image for this post let's display it */}


          <div className="text-center">
            {featuredImage?.data ? (
            <GatsbyImage
              image={featuredImage.data}
              alt={featuredImage.alt}
              style={{ marginBottom: 50 }}
            />
          ):
          (null)
            }
          
          </div>
        </header>

        {!!post.content && (
          <section itemProp="articleBody">{parse(post.content)}</section>
        )}
        <DemoSection
          bgOff
          buttonHref="/demo"
          boldAfter
          headline="Start Your Success with "
          headlineBold ="Doctor Genius Today!"
          paragraph="From new patient acquisition to retention, Doctor Genius has you covered. Explore our plans and features to determine your practice's best option."
        />
        </div>
        <footer>
        {/* <Bio /> */}
        </footer>
      </article>

      
    </Layout>
  )
        }

export default BlogPostTemplate
export const Head = ({ data: { post, site } }) => <Seo title={post.title + " | The Study"} description={post.excerpt} image={site.siteMetadata.siteUrl + post.featuredImage.node.localFile.childImageSharp.fluid.srcWebp} />
{/* export const Head = ({ data: { post, site } }) => {
<Seo 
  title={post.title + " | The Study"} 
  description={post.excerpt} 
  image={post.featuredImage && post.featuredImage.node && post.featuredImage.node.localFile && post.featuredImage.node.localFile.childImageSharp ? site.siteMetadata.siteUrl + post.featuredImage.node.localFile.childImageSharp.fluid.srcWebp : null}
/>} */}


export const pageQuery = graphql`
  query BlogPostById(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site: site {
      siteMetadata {
        siteUrl
      }
    }
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      date(formatString: "MMMM DD, YYYY")
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              fluid {
                srcWebp
              }
              gatsbyImageData(
                quality: 100
                placeholder: DOMINANT_COLOR
                layout: CONSTRAINED
              )
            }
          }
        }
      }
      author {
        node {
          name
          slug
          avatar {
            url
          }
        }
      }
    }
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
      slug
    }
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
      slug
    }
  }
`
